import i18n from '@/i18n'
import store from '@/store'

export default (error) => {
  const confirmation = new Promise((resolve, reject) => {
    store.dispatch('showModal', {
      component: {
        is: 'MessageModal',
        data: {
          message: i18n.t('sentence.conflictModalText')
        }
      },
      options: {
        title: i18n.t('sentence.conflictModalTitle'),
        canClose: false,
        size: 'sm'
      },
      events: {
        ok: () => resolve(),
        cancel: () => reject(error)
      },
      actions: [{
        onClick: ({ cancel }) => cancel(),
        options: {
          title: i18n.t('label.conflictModalCancel'),
          variant: 'link',
          class: 'mr-3'
        }
      }, {
        onClick: ({ ok }) => ok(),
        options: {
          title: i18n.t('label.conflictModalConfirmation'),
          variant: 'danger',
          isPill: true
        }
      }]
    })
  })

  return confirmation
}
